/**
 * FAQ topics as tabs. The server renders every panel and hides the topic
 * buttons, so without JS every topic reads in order. This shows the buttons
 * and keeps one panel open.
 */

export default function initFaq() {
	document.querySelectorAll('[data-awdd-faq]').forEach((root) => {
		const tabs = root.querySelector('[data-awdd-faq-tabs]');
		const buttons = Array.from(root.querySelectorAll('[data-awdd-faq-tab]'));
		const panels = Array.from(root.querySelectorAll('[data-awdd-faq-panel]'));
		if (!tabs || !buttons.length || buttons.length !== panels.length) return;

		const show = (index) => {
			buttons.forEach((b, i) => b.setAttribute('aria-pressed', i === index ? 'true' : 'false'));
			panels.forEach((p, i) => { p.hidden = i !== index; });
		};

		buttons.forEach((b, i) => b.addEventListener('click', () => show(i)));
		tabs.hidden = false;
		show(Math.max(0, buttons.findIndex((b) => b.getAttribute('aria-pressed') === 'true')));
	});
}
